import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

export const CircleCheckIcon = () => (
  <FontAwesomeIcon icon={faCircleCheck} className="mr-1 size-4 text-blue" />
);
